/** French. */
export const fr = {
    common: {
        save: 'Enregistrer',
        saving: 'Enregistrement…',
        saved: 'Enregistré',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        close: 'Fermer',
        back: 'Retour',
        retry: 'Réessayer',
        loading: 'Chargement…',
        search: 'Rechercher',
        signOut: 'Se déconnecter',
        store: 'Boutique',
        status: 'Statut',
        email: 'E-mail',
        password: 'Mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Téléphone',
        total: 'Total',
        subtotal: 'Sous-total',
        quantity: 'Quantité',
        price: 'Prix',
        stock: 'Stock',
        language: 'Langue',
        never: 'Jamais',
        none: '—',
    },
    nav: {
        products: 'Produits',
        orders: 'Commandes',
        customers: 'Clients',
        settings: 'Paramètres',
        website: 'Site web',
        apps: 'Applications',
        themes: 'Thèmes',
        installs: 'Installations',
    },
    auth: {
        signInTitle: 'Connexion',
        signInSubtitle: 'Connectez-vous à l’administration de votre boutique.',
        partnerSubtitle: 'Créez des applications et des thèmes pour les marchands.',
        signIn: 'Se connecter',
        signingIn: 'Connexion…',
        createStore: 'Créez votre boutique',
        creatingStore: 'Création de votre boutique…',
        haveAccount: 'Vous avez déjà une boutique ? Connectez-vous',
        needAccount: 'Pas encore de boutique ? Créez-en une',
        storeName: 'Nom de la boutique',
        storeAddress: 'Adresse de la boutique',
        passwordHint: 'Au moins 12 caractères',
        slugChecking: 'Vérification de la disponibilité…',
        slugTaken: '{{slug}} est déjà pris. Nous suggérons {{suggestion}}.',
        slugFree: '{{slug}} est disponible.',
    },
    products: {
        title: 'Produits',
        searchPlaceholder: 'Rechercher par titre, identifiant ou fournisseur…',
        newProduct: 'Nouveau produit',
        columnProduct: 'Produit',
        columnPrice: 'Prix',
        columnStock: 'Stock',
        columnVariants: 'Déclinaisons',
        statusActive: 'Actif',
        statusDraft: 'Brouillon',
        statusArchived: 'Archivé',
        empty: 'Aucun produit pour le moment. Ajoutez le premier pour commencer à vendre.',
        variantCount: { one: '{{count}} déclinaison', other: '{{count}} déclinaisons' },
        stockLevel: {
            zero: 'Épuisé',
            one: '{{count}} en stock',
            other: '{{count}} en stock',
        },
        variantTitle: 'Nom de la déclinaison',
        sku: 'UGS',
        couldNotLoadVariants: 'Impossible de charger les déclinaisons.',
    },
    orders: {
        title: 'Commandes',
        searchPlaceholder: 'Rechercher par numéro de commande ou e-mail…',
        columnOrder: 'Commande',
        columnCustomer: 'Client',
        columnPayment: 'Paiement',
        columnFulfilment: 'Préparation',
        columnPlaced: 'Passée le',
        shipTo: 'Livrer à',
        item: 'Article',
        qty: 'Qté',
        unit: 'Unité',
        empty: 'Aucune commande pour le moment.',
        itemCount: { one: '{{count}} article', other: '{{count}} articles' },
        financial: {
            PENDING: 'Paiement en attente',
            AUTHORIZED: 'Autorisé',
            PAID: 'Payé',
            PARTIALLY_REFUNDED: 'Partiellement remboursé',
            REFUNDED: 'Remboursé',
            VOIDED: 'Annulé',
        },
        fulfilment: {
            UNFULFILLED: 'Non préparée',
            PARTIAL: 'Partiellement préparée',
            FULFILLED: 'Préparée',
            RESTOCKED: 'Remise en stock',
        },
    },
    customers: {
        title: 'Clients',
        searchPlaceholder: 'Rechercher par nom ou e-mail…',
        newCustomer: 'Nouveau client',
        columnCustomer: 'Client',
        columnOrders: 'Commandes',
        columnMarketing: 'Marketing',
        lifetimeSpend: 'Total dépensé',
        acceptsMarketing: 'Accepte le marketing',
        empty: 'Aucun client pour le moment.',
        orderCount: {
            zero: 'Aucune commande',
            one: '{{count}} commande',
            other: '{{count}} commandes',
        },
    },
    settings: {
        title: 'Paramètres de la boutique',
        storefront: 'Votre boutique en ligne',
        storefrontHint: 'Elle est déjà en ligne. En développement local, le sous-domaine n’est pas dans le DNS : le serveur de développement fixe l’en-tête Host à la place.',
        details: 'Informations',
        customDomain: 'Domaine personnalisé',
        customDomainHint: 'Pointez un CNAME vers Upweo, puis saisissez uniquement le nom d’hôte. Laissez vide pour utiliser l’adresse ci-dessus.',
        addressHint: '{{host}} — la modifier cassera les liens existants',
        currency: 'Devise',
        country: 'Pays',
        plan: 'Formule',
        currencyLocked: 'La devise ne peut plus changer une fois des commandes enregistrées : les totaux historiques n’auraient plus de sens.',
        languages: 'Langues',
        defaultLanguage: 'Langue par défaut',
        defaultLanguageHint: 'Ce que voit un client dont le navigateur demande une langue que vous ne proposez pas.',
        storefrontLanguages: 'Langues de la boutique',
        storefrontLanguagesHint: 'Les clients peuvent basculer entre les langues cochées. Décochez-en une pour la masquer plutôt que d’afficher une boutique à moitié traduite.',
        saveFailed: 'Impossible d’enregistrer les paramètres',
    },
    payments: {
        title: 'Paiements',
        testMode: 'Mode test',
        live: 'En production',
        needsWebhook: 'Webhook manquant',
        notConnected: 'Non connecté',
        account: 'Compte',
        secretKey: 'Clé secrète',
        publishableKey: 'Clé publiable',
        webhookSecret: 'Clé de signature du webhook',
        verified: 'Vérifié',
        webhookEndpoint: 'Point de terminaison du webhook',
        connect: 'Connecter Stripe',
        update: 'Mettre à jour les clés',
        disconnect: 'Déconnecter',
        verifying: 'Vérification…',
        savedAndVerified: 'Enregistré et vérifié',
        copy: 'Copier',
        copied: 'Copié',
        disabledNotConnected: 'Le paiement est désactivé tant qu’aucun compte Stripe n’est connecté. Les clients peuvent parcourir la boutique et remplir un panier, mais pas payer.',
        disabledNoWebhook: 'Vos clés sont enregistrées, mais le paiement reste désactivé tant que la clé de signature du webhook n’est pas ajoutée. Sans elle, nous pouvons lancer un paiement sans jamais apprendre qu’il a réussi : les commandes resteraient impayées pendant que l’argent arrive sur Stripe.',
        secretKeyHintNew: 'Commence par sk_ ou rk_. Stockée chiffrée et jamais réaffichée.',
        secretKeyHintExisting: 'Laissez vide pour conserver la clé déjà enregistrée.',
        publishableKeyHint: 'Commence par pk_. Envoyée au navigateur du client : elle est publique par nature.',
        webhookSecretHint: 'Commence par whsec_. Stripe ne l’affiche qu’une fois, à la création du point de terminaison.',
        saveFailed: 'Impossible d’enregistrer les paramètres de paiement',
        disconnectFailed: 'Impossible de déconnecter',
    },
    shop: {
        shopAll: 'Tout voir',
        searchPlaceholder: 'Rechercher…',
        soldOut: 'Épuisé',
        addToCart: 'Ajouter au panier',
        adding: 'Ajout…',
        options: 'Options',
        productNotFound: 'Produit introuvable',
        continueShopping: 'Continuer mes achats',
        poweredBy: '{{store}} — propulsé par Upweo',
        cart: 'Panier',
        cartEmpty: 'Votre panier est vide',
        decreaseQuantity: 'Diminuer la quantité',
        increaseQuantity: 'Augmenter la quantité',
        remove: 'Retirer',
        taxNotice: 'La TVA et la livraison ne sont pas encore calculées.',
        checkout: 'Commander',
        contact: 'Contact',
        shippingAddress: 'Adresse de livraison',
        address: 'Adresse',
        city: 'Ville',
        postcode: 'Code postal',
        country: 'Pays',
        orderSummary: 'Récapitulatif',
        editCart: 'Modifier le panier',
        continueToPayment: 'Passer au paiement · {{total}}',
        preparingPayment: 'Préparation du paiement…',
        payment: 'Paiement',
        pay: 'Payer {{total}}',
        paying: 'Paiement…',
        paymentSecurity: 'Les paiements sont traités par Stripe. Vos données de carte ne sont jamais transmises à cette boutique.',
        paymentFailed: 'Le paiement a échoué. Essayez une autre carte.',
        thankYou: 'Merci',
        orderPaid: 'La commande {{order}} de {{total}} est payée.',
        confirmationSent: 'Une confirmation part vers {{email}}.',
        cartCount: { zero: 'Panier', one: 'Panier ({{count}})', other: 'Panier ({{count}})' },
    },
    partner: {
        title: 'Upweo Partners',
        apps: 'Applications',
        newApp: 'Nouvelle application',
        clientId: 'Identifiant client',
        clientSecret: 'Secret client',
        scopes: 'Autorisations',
        requestedScopes: 'Autorisations demandées',
        installs: 'Installations',
        grantedScopes: 'Autorisations accordées',
        installed: 'Installée',
        themes: 'Thèmes',
        noThemes: 'Aucun thème pour le moment.',
        noApps: 'Aucune application pour le moment.',
        activePartnerAccount: 'Compte partenaire actif',
        installCount: {
            zero: 'Aucune installation',
            one: '{{count}} installation',
            other: '{{count}} installations',
        },
    },
    website: {
        subtitle: 'Le site public sur upweo.com',
        copy: 'Textes marketing',
        copyHint: 'Laissez un champ vide pour utiliser le texte fourni par Upweo. Ce qui apparaît en gris est le texte actuel pour cette langue.',
        clearHint: 'Vider un champ rétablit le texte d’origine.',
        pricing: 'Formules tarifaires',
        pricingHint: 'Les prix s’affichent au format numérique de chaque visiteur. Seul le texte est traduit : le montant reste identique partout.',
        published: 'En ligne',
        hidden: 'Masqué',
        publish: 'Publier',
        hide: 'Masquer',
        popular: 'Le plus choisi',
    },
    site: {
        nav: {
            features: 'Fonctionnalités',
            pricing: 'Tarifs',
            partners: 'Partenaires',
            signIn: 'Se connecter',
            startFree: 'Commencer gratuitement',
        },
        hero: {
            title: 'Tout ce qu’il faut pour vendre en ligne',
            subtitle: 'Upweo vous donne une boutique, un paiement et les outils pour piloter l’activité derrière — dans votre langue, dans votre devise, sur votre propre domaine.',
            ctaPrimary: 'Créer ma boutique',
            ctaSecondary: 'Voir les tarifs',
            note: 'Aucune carte requise pour commencer.',
        },
        features: {
            heading: 'Conçu pour de vraies boutiques',
            subheading: 'Les parties fastidieuses d’un commerce en ligne, déjà faites.',
            f1Title: 'Votre propre boutique',
            f1Body: 'Chaque boutique reçoit son adresse dès l’inscription, et peut passer à votre nom de domaine quand vous le souhaitez.',
            f2Title: 'Produits et stock',
            f2Body: 'Des déclinaisons avec leur prix et leur UGS, un stock suivi par emplacement, et l’inventaire réservé dès la commande.',
            f3Title: 'De vrais paiements',
            f3Body: 'Connectez votre propre compte Stripe. L’argent de vos clients vous parvient directement : nous ne sommes jamais au milieu.',
            f4Title: 'Parle la langue de vos clients',
            f4Body: 'Six langues, prise en charge de l’écriture de droite à gauche, et des prix formatés comme chaque pays les écrit. Les reçus arrivent dans la langue que lisait le client.',
            f5Title: 'Commandes et clients',
            f5Body: 'Chaque commande est figée au moment de l’achat : votre historique reste exact quoi qu’il arrive au catalogue.',
            f6Title: 'Applications et thèmes',
            f6Body: 'Un écosystème de partenaires avec OAuth, permissions restreintes et webhooks, pour étendre votre boutique sans toucher à vos données.',
        },
        pricing: {
            heading: 'Des tarifs simples',
            subheading: 'Commencez gratuitement. Montez en gamme quand les commandes suivent.',
            perMonth: '/mois',
            cta: 'Commencer',
            popular: 'Le plus choisi',
            placeholderNotice: 'Ces montants sont provisoires pendant la bêta d’Upweo. Rien n’est facturé aujourd’hui.',
            empty: 'Les tarifs sont en cours de finalisation. Créer une boutique reste gratuit en attendant.',
        },
        partners: {
            heading: 'Développez pour Upweo',
            subheading: 'Créez des applications et des thèmes pour les marchands, avec un vrai flux OAuth, des permissions restreintes et des webhooks.',
            cta: 'Devenir partenaire',
            signIn: 'Connexion partenaire',
            b1Title: 'De vraies API',
            b1Body: 'Une API GraphQL publique pour la boutique et une API REST d’administration, toutes deux versionnées.',
            b2Title: 'Accès restreint',
            b2Body: 'Les marchands accordent exactement les permissions demandées, et peuvent les révoquer.',
            b3Title: 'Webhooks',
            b3Body: 'Abonnez-vous aux événements qui comptent, avec une livraison signée et réessayée.',
        },
        signup: {
            heading: 'Créer votre boutique',
            subheading: 'Cela prend une minute. Tout est modifiable ensuite.',
            submit: 'Créer ma boutique',
            submitting: 'Création de votre boutique…',
            haveAccount: 'Vous vendez déjà avec Upweo ? Connectez-vous',
            success: 'Votre boutique est prête. Direction votre tableau de bord…',
        },
        partnerSignup: {
            heading: 'Devenir partenaire',
            subheading: 'Dites-nous qui vous êtes. Nous examinons les nouveaux partenaires avant la publication de leurs applications.',
            accountName: 'Nom de l’entreprise ou du développeur',
            submit: 'Créer le compte partenaire',
            submitting: 'Création de votre compte…',
            success: 'Votre compte partenaire est créé et en attente de validation. Direction le portail…',
            haveAccount: 'Déjà partenaire ? Connectez-vous',
            existingUserHint: 'Vous avez déjà un compte Upweo ? Utilisez les mêmes identifiants et nous y ajouterons l’accès partenaire.',
        },
        footer: {
            tagline: 'Le commerce multi-boutiques, construit à ciel ouvert.',
            product: 'Produit',
            forPartners: 'Pour les partenaires',
            rights: '© {{year}} Upweo',
        },
    },
    errors: {
        BAD_REQUEST: 'Cette requête n’a pas pu être comprise.',
        VALIDATION_FAILED: 'Veuillez vérifier les champs signalés.',
        UNAUTHENTICATED: 'Veuillez vous reconnecter.',
        FORBIDDEN: 'Vous n’avez pas l’autorisation de faire cela.',
        TENANT_NOT_RESOLVED: 'Nous n’avons pas pu déterminer de quelle boutique il s’agit.',
        NOT_FOUND: 'Introuvable.',
        CONFLICT: 'Cela entre en conflit avec un élément existant.',
        RATE_LIMITED: 'Trop de tentatives. Veuillez patienter un instant.',
        PAYMENT_FAILED: 'Le paiement n’a pas pu aboutir.',
        INTERNAL_ERROR: 'Une erreur est survenue de notre côté.',
        network: 'Impossible de joindre le serveur. Vérifiez votre connexion.',
    },
    email: {
        orderConfirmation: {
            subject: 'Commande {{order}} confirmée',
            preheader: 'Nous avons bien reçu votre commande et votre paiement.',
            heading: 'Merci pour votre commande',
            greeting: 'Bonjour {{name}},',
            intro: '{{store}} a bien reçu votre commande et votre paiement a été accepté.',
            orderLabel: 'Commande',
            datePlaced: 'Passée le',
            itemsHeading: 'Votre commande',
            subtotal: 'Sous-total',
            shipping: 'Livraison',
            tax: 'TVA',
            total: 'Total',
            shippingTo: 'Livrer à',
            nextSteps: 'Nous vous écrirons de nouveau à l’expédition de votre commande.',
            footer: 'Cet e-mail vous est envoyé par {{store}}.',
        },
        passwordReset: {
            subject: 'Réinitialisez votre mot de passe Upweo',
            preheader: 'Un lien pour choisir un nouveau mot de passe.',
            heading: 'Réinitialisez votre mot de passe',
            intro: 'Quelqu’un a demandé la réinitialisation du mot de passe de {{email}}.',
            action: 'Choisir un nouveau mot de passe',
            expiry: 'Ce lien ne fonctionne qu’une fois et expire dans {{minutes}} minutes.',
            ignore: 'Si vous n’êtes pas à l’origine de cette demande, ignorez cet e-mail : votre mot de passe n’a pas changé.',
            footer: 'Envoyé par Upweo.',
        },
    },
};
//# sourceMappingURL=fr.js.map